<template>
  <el-header id="header" class="header" height="3rem">
    <el-row type="flex" class="header_panel">
      <el-col :span="8">
        <a class="title" type="primary" :underline="false" href="/">{{ title }}</a>
      </el-col>
      <el-col :span="16" v-if="isLogin">
        <el-menu
          default-active="defaultActive"
          class="menu"
          mode="horizontal"
          @select="menuSelect"
          background-color="#6777ef"
          text-color="#efefef"
          active-text-color="#ffffff"
        >
          <el-menu-item disabled style="user-select: none;opacity:1" index="1">欢迎：{{ nickName }}</el-menu-item>
          <el-menu-item index="2"
            ><i class="el-icon-question"></i>
            <a style="text-decoration: none;" href="/doc/青少司U系列赛事体系建设管理系统帮助文档.docx">
              帮助
            </a>
          </el-menu-item>
          <el-menu-item index="updatePwd"><i class="el-icon-key" @></i>修改密码</el-menu-item>
          <el-menu-item index="logout"><i class="el-icon-right"></i>退出</el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </el-header>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      defaultActive: ""
    };
  },
  computed: {
    ...mapState({
      title: state => state.title,
      nickName: state => (state.userInfo ? state.userInfo.nickName : "游客")
    }),
    ...mapGetters({
      isLogin: "isLogin"
    })
  },
  methods: {
    menuSelect(key) {
      switch (key) {
        case "logout":
          this.logout();
          break;
        case "updatePwd":
          this.updatePwd();
          break;
      }
    },
    logout() {
      this.$confirm("您将要退出系统，是否继续？", "安全退出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.commit("loginOut");
        this.$router.push("/login");
      });
    },
    /**修改密码 */
    updatePwd() {
      /**判断是否处于修改默认密码 */
      if (this.$route.path === "/updatepwd") {
        return;
      }
      this.$router.push(`/management/${this.$route.meta.index.split("/")[2]}/updatepwd`);
    }
  }
};
</script>
<style lang="scss" scoped>
.header {
  box-shadow: 0px 1px 4px rgba(0, 21, 41, 0.12);
  z-index: 99;
  padding: 0 2rem;
  background-color: #6777ef;
  .header_panel {
    .title {
      font-size: 1.13rem;
      text-decoration: none;
      text-decoration: -moz-none;
      font-weight: 700;
      color: #ffffff;
      line-height: 3rem;
    }
    .menu {
      float: right;
      .el-menu-item {
        line-height: 3rem;
        height: 3rem;
        i {
          color: #ffffff;
        }
      }
      .el-menu-item:first-child {
        // color: #303133;
        cursor: auto;
      }
      .el-menu-item.is-active {
        border-bottom: 2px solid transparent !important;
      }
    }
  }
}
</style>
